import axios from 'axios';

export const brandApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/brands`,
    headers: {
        'Content-Type': 'application/json'
    }
})